module.exports = __webpack_public_path__ + "img/header-diamondJewelrySignet.9788305.webp";